module.exports = __webpack_public_path__ + "img/王思雨.6ec5345e.jpg";